import { ComparerType } from 'src/app/modules/reporting/process-reporting/process-group-compaper/process-group-comparer.type';
import { ActionableInsightStatus, ActionableInsightCategory, Platform } from '../../enums/generated.enums';
import { OverviewChartType } from '../../enums/overview-chart-type.enum';
import { SubPageType } from '../../enums/page-type.enum';
import { ProcessMapMetric } from '../../enums/process-map-metric.enum';
import { ProcessPerformanceChartType } from '../../enums/process-performance-chart-type.enum';
import { ScheduleType } from '../../enums/schedule-type.enum';
import { DateRange } from '../date-range.type';
import { FiltersSettings } from './filters-settings.type';
import { IncidentsFilters } from './incidents-filters.type';
import { MonitoringSettings } from './monitoring.settings.type';
import { ExtendedDateRange } from '../extended-date-range.type';
import { OrganizationSettings } from './settings.type';

export class SessionStorageData {
  globalDateRange: DateRange;

  dateRanges: Record<string, ExtendedDateRange> = {};

  monitoringSettings: MonitoringSettings = {
    processes: { filters: {} },
    resources: { filters: {} },
    sessions: { filters: {} },
    pastSchedule: { filters: {} },
    licensesUtilization: { filters: {} },
    resourcesUtilization: { filters: {} },
  };

  eventLogFilters: FiltersSettings;
  auditLogFilters: FiltersSettings;
  incidentsFilters: IncidentsFilters;

  // processes page
  monitoringProcessesDateRange?: string[] = undefined;
  processesDomainId?: string = undefined;
  processesComparer: ComparerType = undefined;

  // process page
  processPerformanceItemsChartType: ProcessPerformanceChartType = undefined;
  processPerformanceSessionsChartType: ProcessPerformanceChartType = undefined;

  // utilization page
  activeUtilizationSubPage: SubPageType.Licenses | SubPageType.Resources = undefined;
  processScheduleType: ScheduleType = undefined;
  processScheduleOrderBy: string = undefined;
  selectedUtilizationFilter: string = undefined;

  // process
  selectedProcessId: string = undefined;
  selectedMasterProcessId: string = undefined;
  currentVariantId: string = undefined;
  openDialogName: string = undefined;
  selectedNodeEdgeId: string = undefined;
  overviewChartType: OverviewChartType = undefined;
  processMap: Record<
    string,
    {
      displayedNodes?: number[];
      expandedNodeIds?: number[];
      selectedVariantIds?: string[];
      zoom?: number;
      position?: { x: number; y: number };
    }
  > = {};

  activeCostAnalysisView: string = undefined;
  selectedFlameGraphDetailId: string = undefined;
  selectedActivityTypeDetailId: string = undefined;

  // organization settings
  actionableInsightFilterState: ActionableInsightStatus | '' = undefined;
  actionableInsightSelectedCategories: ActionableInsightCategory[] = undefined;
  masterProcessTableSortDirection: string = undefined;
  processMapSettingsMetrics = [ProcessMapMetric.LogsCount, ProcessMapMetric.MeanDuration, ProcessMapMetric.AveragePrice];
  uploadFilesSelectedPlatform: Platform = undefined;
  organizationSettings: OrganizationSettings = {
    resources: { filters: {}, sort: undefined },
    tenants: { selectedTenantId: null },
  } as OrganizationSettings;

  // filtering storage
  filterStorage = {} as Record<string, Record<string, string[]>>;
}
